import React from "react";
import "./css/Footer.scss";
import { useMediaQuery } from "react-responsive";

const Footer = ({ args }) => {
  const isDesktop = useMediaQuery({ query: "(min-width: 1025px)" });
  const isTablet = useMediaQuery({ query: "(min-width: 768px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  if (args.styles !== undefined) {
    return (
      <>
        {isMobile && (
          <div className='footer' style={args.styles}>
            Powered by TopLogic Consulting Corporation. All rights reserved ©
            2021.
          </div>
        )}
        {isDesktop && (
          <div className='footer' style={args.styles}>
            Powered by TopLogic Consulting Corporation. All rights reserved ©
            2021.
          </div>
        )}
      </>
    );
  } else {
    return (
      <div
        className='footer'
        style={{
          height: 50,
          width: args.width,
        }}
      >
        Powered by TopLogic Consulting Corporation. All rights reserved © 2021.
      </div>
    );
  }
};

export default Footer;
